import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { NgClass } from '@angular/common';
import {
    SelectComponent,
    OptionComponent,
    IconComponent,
    ButtonComponent,
    TooltipDirective
} from '@epd/pattern-library';

import { DiscoveryOption } from '../../../../interfaces/dropdown.interface';
import { StreamingLeftNavigationService } from './left-navigation.service';
import { StreamingConversationHistoryComponent } from '../conversation-history/streaming-conversation-history.component';
import { ConversationPersistenceService } from '../conversation-persistence/conversation-persistence.service';
import { RealtimeSessionStreamService } from '../realtime-session-stream/realtime-session-stream.service';

@Component({
    selector: 'craig-streaming-navigation',
    standalone: true,
    imports: [
        SelectComponent,
        OptionComponent,
        IconComponent,
        NgClass,
        ButtonComponent,
        TooltipDirective,
        StreamingConversationHistoryComponent
    ],

    templateUrl: './left-navigation.component.html',
    styleUrls: ['./left-navigation.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LeftNavigationComponent implements AfterViewInit {
    @ViewChild('dropdownComponent', { static: true }) discoveryDropdown!: SelectComponent;

    isDiscoveryDropdownOpened: boolean = false;

    discoveryOptions: DiscoveryOption[] = [
        { id: '1', label: 'Part Analysis/Comparison (Coming Soon)' },
        { id: '2', label: 'Alternates (Coming Soon)' },
        { id: '3', label: 'Environmental/Compliance (Coming Soon)' },
        { id: '4', label: 'Substance (Coming Soon)' },
        { id: '5', label: 'Pricing and Availability (Coming Soon)' }
    ];

    constructor(
        private readonly leftNavigationService: StreamingLeftNavigationService,
        private readonly changeDetectorRef: ChangeDetectorRef,
        private readonly _window: Window,
        private readonly conversationPersistenceService: ConversationPersistenceService,
        private readonly realtimeStreamService: RealtimeSessionStreamService
    ) {}

    ngAfterViewInit(): void {
        // this.discoveryDropdown.selectComponent.nzOpenChange.subscribe((isOpen: boolean) => {
        //     this._window.setTimeout(() => {
        //         this.isDiscoveryDropdownOpened = isOpen;
        //         this.changeDetectorRef.detectChanges();
        //     });
        // });
    }

    startNewConversation(): void {
        // console.log('🚀 [LeftNavigationComponent] Start new conversation clicked');

        // Track conversation start for funnel analysis
        this.trackConversationStart();

        // Clear any selected session
        this.leftNavigationService.selectConversationSession(null);

        // Reset realtime session stream state
        this.realtimeStreamService.resetConversation();

        // Start a new session in conversation history
        this.conversationPersistenceService.startNewSession();

        // Show conversation
        this.leftNavigationService.showConversation();
    }

    onDiscoveryDropdownClick(event: Event): void {
        event.stopPropagation();

        if (!this.isDiscoveryDropdownOpened) {
            this.discoveryDropdown.selectComponent.setOpenState(true);
        }
    }

    showIntroductionPanel(): void {
        this.leftNavigationService.hideConversation();
    }

    provideCraigFeedback(): void {
        this._window.open('https://forms.office.com/r/zd3LWvm43p', '_blank');
    }

    goToDemo(): void {
        this._window.open('https://demo.accuristech.com/share/x1918fnh9twx', '_blank');
    }

    /**
     * Track conversation start event for New Relic funnel analysis
     */
    private trackConversationStart(): void {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newrelic = (window as any).newrelic;

        if (newrelic && newrelic.addPageAction) {
            const conversationId = this.conversationPersistenceService.getCurrentConversationId();

            newrelic.addPageAction('conversation_started', {
                conversationId: conversationId,
                timestamp: new Date().toISOString(),
                sessionId: this.generateSessionId(),
                userAgent: navigator.userAgent,
                viewportSize: `${window.innerWidth}x${window.innerHeight}`,
                triggerSource: 'start_new_conversation_button'
            });
        }
    }

    /**
     * Generate a session ID for tracking user sessions
     */
    private generateSessionId(): string {
        // Try to get existing session ID from localStorage, or create a new one
        const existingSessionId = localStorage.getItem('craig_session_id');
        if (existingSessionId) {
            return existingSessionId;
        }

        const sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
        localStorage.setItem('craig_session_id', sessionId);
        return sessionId;
    }
}
